export default __webpack_public_path__ + "static/SamsungOne-600-02cfcb49530da220a5d5c820371e6eb8.ttf";